import React, { Fragment } from 'react'
import { object, array } from 'prop-types'

import Title from '@/component/Primitive/Title'
import Stack from '@/component/Primitive/Stack'
import TypeSpecificCardGrid from '@/component/Primitive/TypeSpecificCardGrid'

const ExecutiveArticlesWidget = ({ pageData, executiveArticles }) => {
  const { executive } = pageData
  return (
    <Stack>
      {executiveArticles.map(({ type, articles }, i) => (
        <Fragment key={`ExecutiveArticles--Article--${i}`}>
          <Title
            title={`${type}s with ${executive.name}`}
            ctaLabel="View All"
            to={`/executive/[slug]/all?type=${type}`}
            ctaUrl={`/executive/${executive.slug}/all?type=${type}`}
            bordered="default"
          />
          <TypeSpecificCardGrid hideCta results={articles} numPerRow={4} />
        </Fragment>
      ))}
    </Stack>
  )
}

ExecutiveArticlesWidget.propTypes = {
  pageData: object,
  executiveArticles: array
}

export default ExecutiveArticlesWidget
